"use strict";
// Copyright 2017-2018 Stratumn SAS. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants = __importStar(require("./const"));
exports.constants = constants;
var errors = __importStar(require("./errors"));
exports.errors = errors;
var evidence_1 = require("./evidence");
exports.deserializeEvidence = evidence_1.deserialize;
exports.Evidence = evidence_1.Evidence;
exports.fromEvidenceObject = evidence_1.fromObject;
var link_1 = require("./link");
exports.deserializeLink = link_1.deserialize;
exports.fromLinkObject = link_1.fromObject;
exports.Link = link_1.Link;
var link_builder_1 = require("./link_builder");
exports.LinkBuilder = link_builder_1.LinkBuilder;
var process_1 = require("./process");
exports.Process = process_1.Process;
var ref_1 = require("./ref");
exports.LinkReference = ref_1.LinkReference;
var segment_1 = require("./segment");
exports.deserializeSegment = segment_1.deserialize;
exports.fromSegmentObject = segment_1.fromObject;
exports.Segment = segment_1.Segment;
var signature_1 = require("./signature");
exports.fromSignatureObject = signature_1.fromObject;
exports.sign = signature_1.sign;
exports.Signature = signature_1.Signature;
exports.signLink = signature_1.signLink;
//# sourceMappingURL=index.js.map